import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

import { priceFetcher } from '@/libs/fetcher/presets'
import { ExchangeRates } from '@/types/currency'

export const fetchExchangeRates = () =>
  priceFetcher<ExchangeRates>('/currency/all').then(res => ({
    ...(res?.crypto ?? {}),
    ...(res?.fiat ?? {}),
    USD: 1,
    lastUpdate: Date.now(),
  }))

export const exchangeRatesQueryOptions = () =>
  queryOptions({
    queryKey: ['exchangeRates'],
    queryFn: () => fetchExchangeRates(),
  })

export const useExchangeRates = () => useSuspenseQuery(exchangeRatesQueryOptions())
